<template>
  <!-- <div class="control-section">
    <div class="col-md-8 control-section"> -->
  <div style="height: 200px; width:200px;">
    <ejs-accumulationchart
      ref='pie'
      :theme="theme"
      style="display: block"
      align="center"
      :legendSettings="legendSettings"
      :tooltip="tooltip"
      enableSmartLables="true"
      :enableAnimation="enableAnimation"
      :center="center"
      height="200"
      width="200"
    >
      <e-accumulation-series-collection>
        <e-accumulation-series
          :palettes="palettes"
          :pointColorMapping="pointColorMapping"
          :dataSource="seriesData"
          :startAngle="startAngle"
          :endAngle="endAngle"
          :explodeOffset="explodeOffset"
          :explodeIndex="explodeIndex"
          :radius="radius"
          xName="x"
          yName="y"
          :dataLabel="dataLabel"
          innerRadius="0%"
          explode="true"
        >
        </e-accumulation-series>
      </e-accumulation-series-collection>
    </ejs-accumulationchart>
  </div>
</template>
<style scoped>
</style>
<script>
import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";
import { DropDownList } from "@syncfusion/ej2-vue-dropdowns";
import {
  AccumulationChartPlugin,
  AccumulationTooltip,
  PieSeries,
  AccumulationDataLabel,
  AccumulationLegend,
} from "@syncfusion/ej2-vue-charts";
Vue.use(AccumulationChartPlugin);

let selectedTheme = location.hash.split("/")[1];
selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");

export default Vue.extend({
  props: {
    question: {
      type: [Object, Array],
    },
    countOptionAnswers: {
      type: Object,
      default: () => {},
    },
    responseCount:{
      type:Number,
      default:0,
    }
  },
  data() {
    return {
      theme: theme,
      // seriesData: [
      //   { x: "Chrome", y: 37, text: "37%", fill: "#6FAAB0" },
      //   { x: "UC Browser", y: 17, text: "17%", fill: "#228B22" },
      //   // { x: "iPhone", y: 19, text: "19%", fill: "#228B22" },
      //   // { x: "Others", y: 4, text: "4%", fill: "#498fff" },
      //   // { x: "Opera", y: 11, text: "11%", fill: "#498fff" },
      //   // { x: "Android", y: 12, text: "12%", fill: "#498fff" },
      // ],
      pointColorMapping: "fill",
      palettes: ["#F6B53F", "#6FAAB0", "#FF33F3", "#228B22", "#3399FF"],
      dataLabel: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
      },
      enableSmartLabels: true,
      enableAnimation: false,
      legendSettings: {
        visible: false,
      },
      tooltip: { enable: true, format: "${point.x} : <b>${point.y}</b>" },

      startAngle: "0",
      endAngle: "360",
      radius: "100%",
      explodeOffset: "0",
      explodeIndex: 0,
      center: { x: "50%", y: "50%" },
      title: "Mobile Browser Statistics",
    };
  },
  computed: {
    seriesData() {
      if(!this.question)
      {
        return ;
      }
      if(!this.question.options)
      {
        return;
      }
      const data = this.question.options.map((option) => {
        return {
          x: option.text,
          y: this.countOptionAnswers[option.value],
          text: `${(
            (this.countOptionAnswers[option.value] /
              this.responseCount) *
            100
          ).toFixed(2)}%`,
          fill: option.fill,
        };
      });
    
      return data;
    },
  },
  provide: {
    accumulationchart: [
      AccumulationLegend,
      PieSeries,
      AccumulationTooltip,
      AccumulationDataLabel,
    ],
  },
  updated() {
    this.$nextTick(function () {
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    });
  },
  methods: {
    pieangle(e) {
      let angle = document.getElementById("pieangle").value;
      this.endAngle = +angle;
      this.startAngle = +angle;
      document.getElementById("anglevalue").innerHTML = angle;
    },
    pieradius(e) {
      let rad = document.getElementById("pieradius").value;
      this.radius = rad + "%";
      document.getElementById("radiusid").innerHTML = (rad / 100).toFixed(2);
    },
    pieexploderadius(e) {
      let rad = document.getElementById("pieexploderadius").value;
      this.explodeOffset = rad + "%";
      document.getElementById("exploderadius").innerHTML = (rad / 100).toFixed(
        2
      );
    },
    pieexplodeindex(e) {
      let index = document.getElementById("pieexplodeindex").value;
      this.explodeIndex = +index;
      document.getElementById("explodeindex").innerHTML = index;
    },
    piecenterx(e) {
      let x = document.getElementById("x").value;
      this.$refs.pie.ej2Instances.center.x = x + "%";
      document.getElementById("xvalue").innerHTML = x + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
    piecentery(e) {
      let y = document.getElementById("y").value;
      this.$refs.pie.ej2Instances.center.y = y + "%";
      document.getElementById("yvalue").innerHTML = y + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
  },
});
</script>
<style>
.e-accumulationchart {
  height: inherit !important;
  width: inherit !important;
}
.e-chart { 
        width: inherit !important; 
        height: inherit !important; 
    } 
  
</style>